module.exports = function() {
  return new Worker(__webpack_public_path__ + "ce476b9211b5d1ad01b3.worker.js");
};